import { render } from "./ExamTypeForm.vue?vue&type=template&id=59085dd2"
import script from "./ExamTypeForm.vue?vue&type=script&lang=js"
export * from "./ExamTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__